import { useEffect, useRef, useState } from "react";
import { generalObj } from "../../constant/objects_types"
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import BackArrow from "../BackArrow";
import ModalLoader from "./ModalLoader";
import { fetchEventInfluencerTraffic } from "../../action/generalFunc";

const TrafficModal = ({ visible, event, modalClose }:{
    visible: boolean,
    event: generalObj,
    modalClose: () => void
}) => {

    const [firstShow, setFirstShow] = useState<boolean>(false);
    const [modalLoader, setModalLoader] = useState<boolean>(false);
    const [trafficData, setTrafficData] = useState<generalObj[]>([]);
    const [pageMeta, setPageMeta] = useState<generalObj|null>(null);
    const { id } = event;
    const account = useSelector((state:RootState) => state.account);
    const parentRef = useRef<HTMLDivElement | null>(null);
    
    useEffect(() => {
        if (firstShow) return;
        if (!visible) return;
        setFirstShow(true);
    }, [visible, firstShow]);

    useEffect(() => {
        if (!visible || !firstShow) return;
        if (!account || !account.isAuthenticated || !id) return;
        if (trafficData.length > 0) return;
        (async () => {
            setModalLoader(true);
            let result:generalObj = await fetchEventInfluencerTraffic(account.token, id, 1, 20); 
            
            if (result.status) {
                
                setTrafficData(result.data.data.traffics);
                setPageMeta(result.data.data.meta);
            }else {
                alert(result.message);
            }
            setModalLoader(false);
        })();
    }, [visible, firstShow, pageMeta, account, id, trafficData]);

    const loadData = async () => {
        if (!account || !account.isAuthenticated || !id || !trafficData) return;

        setModalLoader(true);
        let page = pageMeta && pageMeta.next_page ? pageMeta.next_page : 1;
        let result:generalObj = await fetchEventInfluencerTraffic(account.token, id, page, 20); 
        if (result.status) {
            let new_traffic = [...trafficData, ...result.data.data.traffics];
            setTrafficData(new_traffic);
            setPageMeta(result.data.data.meta);
        }else {
            alert(result.message);
        }
        setModalLoader(false);
    }

    return (
        <>
            {firstShow && (
                <>
                    <div className={`check__in__modal modalParentContainer${visible ? " animate__animated animate__slideInRight" :  " animate__animated animate__slideOutRight"}`} style={{backgroundColor:"#0D0404"}} ref={parentRef}>
                        <div className="modalContainer" style={{}}>
                            <div style={{width:'100%', height:'100%', position:'relative'}}>
                                <div style={{height:'100%', marginTop:"20px"}}>
                                    <div style={{display:'flex', alignItems:'center', margin:"0px 20px"}}>
                                        <BackArrow onPress={modalClose} arrowStyle={{position:'relative', left:'0', top:"0px", width:'18px'}} arrowBtnStyle={{position:"relative", left:'-6px', top:"2px"}} />
                                        <div className="sectionTitle" style={{fontSize:"13px", lineHeight:"16px"}}>Traffic</div>
                                    </div>
                                    <div style={{display:"flex", alignItems:'center', flexDirection:'column', gap:'15px', height:"100%", marginTop:'10px'}}>
                                        <div style={{backgroundColor:'#353434', width:'100%', textAlign:'center', paddingBlock:'10px'}}>
                                            <div className='sectionTitle' style={{fontSize:'12px', fontWeight:700, textTransform:'capitalize'}}>{event.name}</div>
                                            <div>
                                                <div style={{color:'#9E9B9B', fontSize:'10px', fontWeight:'600'}}>Traffic</div>
                                                {/* <div>{tickets ? tickets.filter((item:generalObj) => (item.used === 1)).length : 0}</div> */}
                                            </div>   
                                        </div>
                                        <div className="bgMain" style={{marginBottom:"10px", marginTop:"12px", width:'100%', paddingBottom:"90px"}}>
                                            
                                            <div style={{marginInline:'20px', marginTop:'20px'}}>
                                                <div style={{marginTop: '20px', overflowX:'hidden', height:`${parentRef.current ? parentRef.current.clientHeight - 250 : 250}px`}}> 
                                                    <div style={{paddingBottom:'120px', display:'flex', flexDirection:'column', gap:'15px'}} id="traffic_content">
                                                        {trafficData.length > 0 && (
                                                            trafficData.map((item:generalObj, index:number) => (
                                                                
                                                                <button key={index} style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}} onClick={() => null}>
                                                                    <div style={{textAlign:'start'}}>
                                                                        <div className='postOwnerTextl' style={{marginLeft:0, textTransform:'capitalize'}}>{item.name}</div>
                                                                        <div className='postOwnerTextl' style={{marginLeft:0, marginTop:'3px', fontSize:'12px', fontWeight:'400', color:'#FFFFFF99'}}>{item.traffic_code}</div>
                                                                    </div>
                                                                    <div style={{textAlign:'start', width:'100%', marginTop:'5px', display:'flex', justifyContent:'space-between'}}>
                                                                        <div className='postOwnerTextl' style={{marginLeft:0, fontSize:'12px', fontWeight:'400', color:'#FFFFFF99'}}><span style={{color:"#FFF"}}>Total Traffic: </span><span style={{textTransform:'capitalize'}}>{item.total_traffic}</span></div>
                                                                        <div className='postOwnerTextl' style={{marginLeft:0, fontSize:'12px', fontWeight:'400', color:'#FFFFFF99'}}><span style={{color:"#FFF"}}>Ticket Sold: </span>{item.total_ticket_sold}</div>
                                                                    </div>
                                                                </button>
                                                            ))
                                                        )}
                                                        {pageMeta && pageMeta.next_page && (
                                                            <button style={{display:'flex', flexDirection:'column', alignItems:'center', backgroundColor:"#353434", color: "#FFFFFF99", textAlign:'center', padding:"10px"}} onClick={() => loadData()}>
                                                                Load more data
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <ModalLoader visible={modalLoader} />
        </>
    )
}

export default TrafficModal;